<template>
  <div
    :class="[
      'c-documents-modal__exercise',
      'c-documents-modal__exercise--editable',
      removal ? 'c-documents-modal__exercise--removal' : '',
      current ? 'c-documents-modal__exercise--current' : '',
    ]"
  >
    <label>
      <input
        type="text"
        :value="modelValue"
        class="c-documents-modal__exercise-name"
        :disabled="removal"
        @input="onChange"
      />
    </label>

    <button v-if="removal" class="c-documents-modal__exercise-delete-undo" @click="remove">
      {{ $t('DOCUMENT_MODAL.UNDO_DELETE') }}
    </button>
    <RemoveIcon v-else tabindex="0" class="c-documents-modal__exercise-delete" @click="remove" @keydown="remove" />
  </div>
</template>

<script lang="ts" setup>
import { KEYS_SPACEBAR_ENTER } from '@/utils/keyboard';
import RemoveIcon from '@/components/remove-icon/RemoveIcon.vue';

interface ExerciseEditProps {
  modelValue: string;
  removal: boolean;
  current: boolean;
}

defineProps<ExerciseEditProps>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
  remove: [];
}>();

const remove = (event) => {
  if (event instanceof KeyboardEvent && !KEYS_SPACEBAR_ENTER.includes(event.key.toLowerCase())) {
    return;
  }

  event.preventDefault();

  emit('remove');
};

const onChange = (event) => {
  emit('update:modelValue', event.target.value);
};
</script>
